/**
 * EIS 电子发票(总部端)页面文案域 pages.eis.*(20 号 v2 §五)
 *
 * 键面:①状态全集双口径(upload 8+tenantUpload 8+email 4+mode 2+health 2+kind 3
 * +deadline 四态);②事件流水 21 键(原型 16+清零轮新增 5,与 21 号 §4.6 全集
 * 对齐);③各页标题/列头/按钮/弹窗/Alert 文案;④表单校验消息。
 * en-US 同键面按语义新译(键集合一致性由 eisLabels.test.ts 钉住)。
 */
export default {
  // ── 通用 ─────────────────────────────────────────────────────────────
  'pages.eis.common.refresh': '刷新',
  'pages.eis.common.tenantFilterAll': '全部租户',
  'pages.eis.common.updatedAt': '更新于 {time} · 每 5 秒自动刷新',
  'pages.eis.common.detail': '详情',
  'pages.eis.common.pdf': 'PDF',
  'pages.eis.common.empty': '暂无数据',
  'pages.eis.common.goHandle': '去处理',
  'pages.eis.common.loading': '加载中…',
  'pages.eis.common.copy': '复制单号',
  'pages.eis.common.copied': '已复制',
  'pages.eis.common.save': '保存',
  'pages.eis.common.unit': '张',

  // ── 状态全集(statusMap,双口径) ─────────────────────────────────────
  'pages.eis.status.upload.HELD': '过渡期暂存',
  'pages.eis.status.upload.PENDING': '待上传',
  'pages.eis.status.upload.SUBMITTING': '上传中',
  'pages.eis.status.upload.SUBMITTED': '已上传·待结果',
  'pages.eis.status.upload.ACCEPTED': 'EIS 已接受',
  'pages.eis.status.upload.REJECTED': 'EIS 拒收',
  'pages.eis.status.upload.FAILED': '上传失败',
  'pages.eis.status.upload.REVIEW': '待人工核对',
  'pages.eis.status.tenantUpload.HELD': '已保存·EIS 未上线',
  'pages.eis.status.tenantUpload.PENDING': '等待推送',
  'pages.eis.status.tenantUpload.SUBMITTING': '推送中',
  'pages.eis.status.tenantUpload.SUBMITTED': '已推送·等待 BIR 确认',
  'pages.eis.status.tenantUpload.ACCEPTED': '推送成功',
  'pages.eis.status.tenantUpload.REJECTED': '推送失败',
  'pages.eis.status.tenantUpload.FAILED': '推送失败',
  'pages.eis.status.tenantUpload.REVIEW': '推送失败·总部处理中',
  'pages.eis.status.email.NO_EMAIL': '无邮箱',
  'pages.eis.status.email.UNSENT': '待发送',
  'pages.eis.status.email.SENT': '已发送',
  'pages.eis.status.email.FAILED': '发送失败',
  'pages.eis.status.mode.HOLD': '过渡期 HOLD',
  'pages.eis.status.mode.LIVE': '正式推送 LIVE',
  'pages.eis.status.health.OK': '正常',
  'pages.eis.status.health.ERROR': '已暂停',
  'pages.eis.status.kind.SALE': '销售发票',
  'pages.eis.status.kind.VOID': '作废调整单',
  'pages.eis.status.kind.RETURN': '退货调整单',
  'pages.eis.kind.code.SALE': '01',
  'pages.eis.kind.code.VOID': '06 / 04',
  'pages.eis.kind.code.RETURN': '06 / 05',
  'pages.eis.status.waitingOriginal': '(等待原单)',

  // ── 期限四态(DeadlineCell,剩余时长由 deadlineAt 推导,A-48) ────────
  'pages.eis.deadline.uploaded': '已上传',
  'pages.eis.deadline.heldExempt': '过渡期不计',
  'pages.eis.deadline.overdue': '已逾期 {hours} 小时',
  'pages.eis.deadline.leftDays': '剩 {days} 天 {hours} 小时',
  'pages.eis.deadline.leftHours': '剩 {hours} 小时 {minutes} 分',

  // ── 事件流水 21 键(21 号 §4.6 全集对齐) ─────────────────────────────
  'pages.eis.event.CREATED': '生成电子发票',
  'pages.eis.event.SUBMITTED': '已推送 EIS(收到回执)',
  'pages.eis.event.ACCEPTED': 'EIS 已接受',
  'pages.eis.event.REJECTED': 'EIS 拒收',
  'pages.eis.event.SUBMIT_FAILED': '推送失败',
  'pages.eis.event.RESUBMIT_SCHEDULED': '批次无法处理,重新推送',
  'pages.eis.event.RESULT_MISSING': '结果缺失,重新推送',
  'pages.eis.event.EMAIL_SENT': '邮件已发送',
  'pages.eis.event.EMAIL_FAILED': '邮件发送失败',
  'pages.eis.event.EMAIL_RESEND_REQUESTED': '申请重发邮件',
  'pages.eis.event.DEADLINE_DUE_SOON': '即将逾期(不足 24 小时)',
  'pages.eis.event.DEADLINE_OVERDUE': '已逾期(超过 3 天未上传)',
  'pages.eis.event.RELEASED': '过渡期补传:转为待上传',
  'pages.eis.event.REGENERATED': '重新生成(新 EIS ID)',
  'pages.eis.event.RESUBMIT_REQUESTED': '手动重传',
  'pages.eis.event.PRE_PTT_BLOCKED': '原单早于 PTT 批准日,冲正票不发送',
  'pages.eis.event.SUBMIT_LOST': '提交回执丢失,自动重试耗尽转人工',
  'pages.eis.event.RECONCILED': '日对账核对一致,清账',
  'pages.eis.event.PRE_PTT_WRITTEN_OFF': 'PRE-PTT 调整单本地核销',
  'pages.eis.event.UNPAID_HOLD': '未支付订单挂起',
  'pages.eis.event.RECONCILE_DIFF': '支付勾稽差异留痕',

  // ── 监控总览页 ───────────────────────────────────────────────────────
  'pages.eis.monitor.title': 'EIS 监控总览',
  'pages.eis.monitor.subTitle':
    '全部租户的电子发票上传与客户邮件状态;点击卡片、图例或关注项可快速筛选下方列表',
  'pages.eis.monitor.unhealthyAlert':
    'EIS 配置「{name}」({cert}) 已暂停推送:{msg}',
  'pages.eis.monitor.unhealthyAlertDesc':
    '修正凭据后到「EIS 配置」测试连接即可恢复,期间单据保留在待上传队列。',
  'pages.eis.monitor.deadlineAlert': '3 天上传期限提醒:{overdue}{dueSoon}',
  'pages.eis.monitor.deadlineAlert.overdue': '{count} 张已逾期',
  'pages.eis.monitor.deadlineAlert.dueSoon': '{count} 张 24 小时内到期',
  'pages.eis.monitor.deadlineAlertDesc':
    '系统不锁机、持续重试并记录;请优先处理配置异常与拒收单据。(补传批次期限事件已按批次聚合计数)',
  'pages.eis.monitor.deadlineAlert.action': '查看单据',
  'pages.eis.monitor.kpi.total': '电子发票总数',
  'pages.eis.monitor.kpi.totalHint': '金额合计 PHP {amount}',
  'pages.eis.monitor.kpi.accepted': 'EIS 已接受',
  'pages.eis.monitor.kpi.acceptedHint': '接受率 {rate}%',
  'pages.eis.monitor.kpi.inflight': '在途',
  'pages.eis.monitor.kpi.inflightHint':
    '待上传 {pending} · 待 BIR 结果 {submitted}',
  'pages.eis.monitor.kpi.problem': '需处理',
  'pages.eis.monitor.kpi.problemHint':
    '拒收 {rejected} · 失败 {failed} · 待核对 {review}',
  'pages.eis.monitor.overview.title': '上传状态分布',
  'pages.eis.monitor.overview.sub': '共 {total} 张',
  'pages.eis.monitor.overview.ACCEPTED': 'EIS 已接受',
  'pages.eis.monitor.overview.SUBMITTED': '已上传·待结果',
  'pages.eis.monitor.overview.PENDING': '待上传',
  'pages.eis.monitor.overview.HELD': '过渡期暂存',
  'pages.eis.monitor.overview.REVIEW': '待人工核对',
  'pages.eis.monitor.overview.REJECTED': 'EIS 拒收',
  'pages.eis.monitor.overview.FAILED': '上传失败',
  'pages.eis.monitor.attention.title': '需要关注',
  'pages.eis.monitor.attention.dueSoon': '即将逾期',
  'pages.eis.monitor.attention.dueSoonHint': '距 3 天截止不足 24 小时',
  'pages.eis.monitor.attention.overdue': '已逾期',
  'pages.eis.monitor.attention.overdueHint': '超过 3 天未上传,只记录 + 提醒',
  'pages.eis.monitor.attention.mail': '邮件发送失败',
  'pages.eis.monitor.attention.mailHint': '可在详情中改邮箱重发',
  'pages.eis.monitor.attention.profile': 'EIS 配置异常',
  'pages.eis.monitor.attention.profileHint':
    '凭据失效 / IP 白名单等,已暂停推送',
  'pages.eis.monitor.trend.title': '每日提交与接受趋势',
  'pages.eis.monitor.trend.sub': '近 14 天(PHT)· 合计接受率 {rate}',
  'pages.eis.monitor.trend.tooltip':
    '{date} · 提交 {submitted}|接受 {accepted}|拒收 {rejected}|在途 {inflight}',
  'pages.eis.monitor.trend.accepted': '当日接受',
  'pages.eis.monitor.trend.rejected': '当日拒收',
  'pages.eis.monitor.trend.inflight': '提交后在途',
  'pages.eis.monitor.errorDist.title': '错误码分布',
  'pages.eis.monitor.errorDist.sub': '按单据计,含待核对校验码',
  'pages.eis.monitor.errorDist.empty': '暂无错误',
  'pages.eis.monitor.table.title': '电子发票明细',
  'pages.eis.monitor.quick.total': '总数',
  'pages.eis.monitor.quick.ACCEPTED': 'EIS 已接受',
  'pages.eis.monitor.quick.inflight': '在途',
  'pages.eis.monitor.quick.problem': '需处理',
  'pages.eis.monitor.quick.HELD': '过渡期暂存',
  'pages.eis.monitor.quick.PENDING': '待上传',
  'pages.eis.monitor.quick.SUBMITTED': '已上传·待结果',
  'pages.eis.monitor.quick.REVIEW': '待人工核对',
  'pages.eis.monitor.quick.REJECTED': 'EIS 拒收',
  'pages.eis.monitor.quick.FAILED': '上传失败',
  'pages.eis.monitor.quick.dueSoon': '即将逾期',
  'pages.eis.monitor.quick.overdue': '已逾期',
  'pages.eis.monitor.quick.emailFailed': '邮件发送失败',
  'pages.eis.monitor.quick.reconciliation': '待对账',
  'pages.eis.monitor.quick.resultCode': '结果码 {code}',

  // ── 明细表列(一列一个字段) ─────────────────────────────────────────
  'pages.eis.column.sourceNo': '单号',
  'pages.eis.column.docKind': '单据类型',
  'pages.eis.column.siNumber': '原 SI 号',
  'pages.eis.column.tenant': '租户',
  'pages.eis.column.store': '门店',
  'pages.eis.column.accreditationId': 'EIS 认证号',
  'pages.eis.column.orderCreatedAt': '订单创建时间 (PHT)',
  'pages.eis.column.issueDtm': '开票时间 (PHT)',
  'pages.eis.column.netAmtPay': '金额 (PHP)',
  'pages.eis.column.uploadStatus': '上传状态',
  'pages.eis.column.resultCode': '结果码',
  'pages.eis.column.deadline': '3 天期限',
  'pages.eis.column.arrivedLate': 'POS 迟到',
  'pages.eis.column.emailStatus': '邮件状态',
  'pages.eis.column.customerEmail': '客户邮箱',
  'pages.eis.column.action': '操作',
  // 搜索表单(hideInTable)
  'pages.eis.search.tenant': '租户',
  'pages.eis.search.store': '门店',
  'pages.eis.search.q': '单号 / EIS ID',
  'pages.eis.search.qPlaceholder': '16 位单号 / SI 号 / EIS ID',
  'pages.eis.search.kind': '单据类型',
  'pages.eis.search.resultCode': '结果码',
  'pages.eis.search.resultCodePlaceholder': '如 SYN003',
  'pages.eis.search.reconciliation': '待对账',
  'pages.eis.search.reconciliationOnly': '仅看待对账单据',
  'pages.eis.search.allTenants': '全部租户',
  'pages.eis.search.allStores': '全部门店',
  'pages.eis.posLate.tooltip':
    'POS 离线,订单上行到云端时已超过 3 天(B-27:责任=POS 侧,只打标不拦截)',
  'pages.eis.posLate.tag': '迟到',

  // ── 数据中心页(R41) ────────────────────────────────────────────────
  'pages.eis.dataCenter.title': '数据中心',
  'pages.eis.dataCenter.subTitle':
    '{tenants} 个租户 · {bound} / {stores} 家门店已绑定 EIS 配置。每个商户各自申请 EIS Cert 与 PTT,同租户不同门店可绑定不同认证号',
  'pages.eis.dataCenter.subTitleLoading': '按租户 → 门店绑定 EIS 配置',
  'pages.eis.dataCenter.tenantBound': '{bound} / {total} 家门店已绑定',
  'pages.eis.dataCenter.metric.total': '电子发票',
  'pages.eis.dataCenter.metric.accepted': '已接受',
  'pages.eis.dataCenter.metric.held': '暂存',
  'pages.eis.dataCenter.metric.problem': '需处理',
  'pages.eis.dataCenter.profiles': 'EIS 配置',
  'pages.eis.dataCenter.profile.manage': '管理配置',
  'pages.eis.dataCenter.profile.create': '新建 EIS 配置',
  'pages.eis.dataCenter.profile.paused': '已暂停',
  'pages.eis.dataCenter.profile.live': '正式推送',
  'pages.eis.dataCenter.profile.hold': '过渡期',
  'pages.eis.dataCenter.column.store': '门店',
  'pages.eis.dataCenter.column.storeId': '门店 ID',
  'pages.eis.dataCenter.column.binding': '绑定 EIS 配置',
  'pages.eis.dataCenter.column.bindingPlaceholder': '选择本租户的 EIS 配置',
  'pages.eis.dataCenter.column.sellerType': 'Seller Type',
  'pages.eis.dataCenter.column.branchCd': 'BranchCd',
  'pages.eis.dataCenter.column.branchCdTooltip':
    '留空则从订单 TIN 后缀解析(如 444-867-786-001 → 00001)',
  'pages.eis.dataCenter.column.branchCdPlaceholder': '自动解析',
  'pages.eis.dataCenter.column.sellerEmail': '卖方邮箱',
  'pages.eis.dataCenter.column.sellerEmailPlaceholder': '可选',
  'pages.eis.dataCenter.column.bound': '绑定状态',
  'pages.eis.dataCenter.column.boundYes': '已绑定',
  'pages.eis.dataCenter.column.boundNo': '未绑定',
  'pages.eis.dataCenter.column.pendingGenerate': '待补生成',
  'pages.eis.dataCenter.column.pendingGenerateTooltip':
    '已上行的电子发票订单,因门店未绑定尚未生成;绑定保存后自动补生成',
  'pages.eis.dataCenter.column.action': '操作',
  'pages.eis.dataCenter.save': '保存',
  'pages.eis.dataCenter.saveChanges': '保存修改',
  'pages.eis.dataCenter.unbind': '解绑',
  'pages.eis.dataCenter.unbindConfirm':
    '解除绑定后,该门店新上行的电子发票暂不生成,确认?',
  'pages.eis.dataCenter.msg.saved': '已保存绑定,补生成 {count} 张电子发票',
  'pages.eis.dataCenter.msg.savedNoBackfill': '已保存绑定',
  'pages.eis.dataCenter.msg.unbound': '已解除绑定',
  'pages.eis.dataCenter.empty': '暂无租户',
  'pages.eis.sellerType.0': '0 VAT',
  'pages.eis.sellerType.1': '1 Non-VAT',
  'pages.eis.sellerType.2': '2 RBE',

  // ── EIS 配置页 ───────────────────────────────────────────────────────
  'pages.eis.profile.title': 'EIS 配置',
  'pages.eis.profile.subTitle':
    '每个商户各自申请 EIS Cert 与 PTT;一张卡片 = 一个 EIS Cert Number,门店在「数据中心」绑定',
  'pages.eis.profile.create': '新建配置',
  'pages.eis.profile.group.count': '{count} 套配置',
  'pages.eis.profile.health.ok': '连接正常',
  'pages.eis.profile.health.error': '已暂停推送',
  'pages.eis.profile.certLabel': 'EIS Cert Number',
  'pages.eis.profile.kv.applicationId': 'Application ID',
  'pages.eis.profile.kv.env': '环境',
  'pages.eis.profile.kv.envSandbox': '沙箱',
  'pages.eis.profile.kv.envProd': '正式环境',
  'pages.eis.profile.kv.voidCorrectionCd': '作废冲正码',
  'pages.eis.profile.kv.voidCd04': '04 Cancellation',
  'pages.eis.profile.kv.voidCd01': '01 Error',
  'pages.eis.profile.kv.pttApprovedOn': 'PTT 批准日',
  'pages.eis.profile.kv.pttNotApproved': '未批准',
  'pages.eis.profile.kv.credentialUpdatedAt': '凭据更新于',
  'pages.eis.profile.kv.baseUrl': 'API 地址',
  'pages.eis.profile.stores.empty': '尚未绑定门店,到「数据中心」绑定',
  'pages.eis.profile.action.test': '测试连接',
  'pages.eis.profile.action.testing': '测试中…',
  'pages.eis.profile.action.testTooltip': '调用 Authentication 接口验证凭据',
  'pages.eis.profile.action.selftest': '沙箱自测',
  'pages.eis.profile.action.selftestTooltip':
    '一键跑通门户沙箱测试:认证×2、开票×1、查询×2,结果留痕可作准入材料(R49)',
  'pages.eis.profile.action.toLive': '切到 LIVE',
  'pages.eis.profile.action.toHold': '切回 HOLD',
  'pages.eis.profile.action.toLiveConfirm':
    '切到 LIVE 后新单据直接上传 EIS,3 天期限生效。确认?',
  'pages.eis.profile.action.toHoldConfirm':
    '切回 HOLD 后新单据只存储不上传;在途单据将转回暂存且不再计 3 天期限。确认?',
  'pages.eis.profile.action.release': '补传暂存',
  'pages.eis.profile.action.edit': '编辑',
  'pages.eis.profile.modeInfo.title': '模式说明',
  'pages.eis.profile.modeInfo.desc':
    'HOLD = 过渡期,只生成并保存电子发票,不调用 EIS;LIVE = 正式推送(3 天期限生效)。EIS 上线后先切 LIVE,再用「补传暂存」按日期区间把积存单据放入上传队列;填写 PTT 批准日后,补传时会提示早于该日的单数。',
  'pages.eis.profile.msg.switched': '已切换',
  'pages.eis.profile.msg.saved': '已保存',
  'pages.eis.profile.test.ok': '连接成功',
  'pages.eis.profile.test.fail': '连接失败',

  // ── ProfileForm(密钥三件只写+掩码回显) ─────────────────────────────
  'pages.eis.form.createTitle': '新建 EIS 配置',
  'pages.eis.form.editTitle': '编辑 EIS 配置:{name}',
  'pages.eis.form.tenantId': '归属租户',
  'pages.eis.form.tenantIdPlaceholder': '选择租户',
  'pages.eis.form.name': '配置名称',
  'pages.eis.form.namePlaceholder': '如:Makati POS 认证',
  'pages.eis.form.accreditationId': 'EIS Cert Number',
  'pages.eis.form.accreditationIdTooltip':
    '请求头 accreditationId,也是 EisUniqueId 的第 9~16 位。POS 为 31 开头,ASP-POS 为 52 开头',
  'pages.eis.form.accreditationIdRule': '8 位数字或大写字母',
  'pages.eis.form.required': '必填',
  'pages.eis.form.applicationId': 'Application ID',
  'pages.eis.form.userId': '门户账号 User ID',
  'pages.eis.form.password': '门户密码',
  'pages.eis.form.appSecret': 'App Secret Key',
  'pages.eis.form.signKeyId': '签名 Key-pair ID',
  'pages.eis.form.signKeyIdTooltip': 'JWS header 的 kid',
  'pages.eis.form.signPrivateKey': '签名私钥 (PEM)',
  'pages.eis.form.signPrivateKeyPlaceholder': '-----BEGIN PRIVATE KEY-----',
  'pages.eis.form.eisPublicKey': 'EIS 公钥',
  'pages.eis.form.eisPublicKeyPlaceholder':
    '留空 = 内置 mock 公钥;生产填 EIS_Certification_Public_Key.txt',
  'pages.eis.form.publicKeySet': '已配置(留空 = 不修改)',
  'pages.eis.form.baseUrl': 'API 地址',
  'pages.eis.form.baseUrlPlaceholder':
    '留空 = 内置沙箱;沙箱 https://eis-cert.bir.gov.ph',
  'pages.eis.form.apiPrefix': 'API 前缀',
  'pages.eis.form.env': '环境',
  'pages.eis.form.mode': '模式',
  'pages.eis.form.modeHOLD': 'HOLD 过渡期',
  'pages.eis.form.modeLIVE': 'LIVE 正式推送',
  'pages.eis.form.minInterval': '开票接口最小间隔',
  'pages.eis.form.minIntervalTooltip':
    '沙箱每 10 秒只能调用 1 次开票接口,填 10000;生产填 0',
  'pages.eis.form.voidCorrectionCd': '作废冲正码',
  'pages.eis.form.voidCorrectionCdTooltip':
    '作废调整单(DocType 06)的 CorrectionCd',
  'pages.eis.form.pttApprovedOn': 'PTT 批准日',
  'pages.eis.form.pttApprovedOnTooltip':
    'EIS 规则:原单开具早于此日的,不得传输冲正票;补传时会提示早于此日的单据数量',
  'pages.eis.form.keepHint': '留空 = 不修改',
  'pages.eis.form.credentialSet': '已配置(留空 = 不修改)',

  // ── ReleaseModal(补传暂存,dry-run/PTT 前提示) ──────────────────────
  'pages.eis.release.title': '补传过渡期暂存:{name}({cert})',
  'pages.eis.release.range': '出单日期',
  'pages.eis.release.rangeTooltip':
    '留空 = 不限;超大量积存时按日期分片逐段放行(B-08)',
  'pages.eis.release.notLive':
    '当前仍是 HOLD 模式:转为待上传后不会推送,请先切到 LIVE。',
  'pages.eis.release.preview': '预览数量',
  'pages.eis.release.execute': '执行补传',
  'pages.eis.release.previewInfo': '该区间内有 {count} 张暂存单据将被补传',
  'pages.eis.release.prePttWarning':
    '其中 {count} 张出单早于 PTT 批准日({date})',
  'pages.eis.release.prePttDesc':
    'BIR 是否接受 PTT 前开具的电子发票补传尚未确认:先照常补传并在沙箱验证,结果以 EIS 回执为准。这些原单的作废/退货调整单按规则不会发送,会转入待人工核对。',
  'pages.eis.release.msg.done': '已转入上传队列 {count} 张',

  // ── SelfTestModal(五步自测向导,R49) ───────────────────────────────
  'pages.eis.selftest.title': '沙箱自测:{name}({cert})',
  'pages.eis.selftest.intro':
    '按 EIS 门户准入要求依次验证 5 个联网步骤:认证 ×2(含强制刷新 token)→ 提交 1 张测试发票 → 查询结果 ×2。测试发票金额 112 PHP,只在 EIS 侧登记、不进入业务单据;结果自动留痕,可作为逐商户准入材料。',
  'pages.eis.selftest.running':
    '正在执行自测(真实沙箱需遵守最小调用间隔,可能较慢)…',
  'pages.eis.selftest.rerun': '重新自测',
  'pages.eis.selftest.close': '关闭',
  'pages.eis.selftest.step.passed': '通过',
  'pages.eis.selftest.step.failed': '失败',
  'pages.eis.selftest.step.noResult': '未出结果',
  'pages.eis.selftest.step.skipped': '跳过',
  'pages.eis.selftest.result.allPassed':
    '自测全部通过:凭据、签名、提交与查询链路可用,可截图留档用于准入申请',
  'pages.eis.selftest.result.failed':
    '自测失败({step}):请按上方提示修正配置后重试',
  'pages.eis.selftest.result.noResult':
    '提交成功但 EIS 尚未出结果:沙箱通常次日可查,可稍后重新自测',
  'pages.eis.selftest.history': '历史记录({count} 次)',
  'pages.eis.selftest.historySteps': '{passed}/{total} 步通过',
  'pages.eis.selftest.historyPass': '通过',
  'pages.eis.selftest.historyFail': '未通过',

  // ── 单据详情抽屉(hq 模式) ──────────────────────────────────────────
  'pages.eis.drawer.title': '{kind}详情',
  'pages.eis.drawer.resubmit': '手动重传',
  'pages.eis.drawer.regenerate': '重新生成',
  'pages.eis.drawer.prevSi': '原 SI {no}',
  'pages.eis.drawer.tenantStore': '{tenant} / {store}',
  'pages.eis.drawer.amountLabel': '金额 PHP',
  'pages.eis.drawer.tab.overview': '概览',
  'pages.eis.drawer.tab.json': 'EIS 报文',
  'pages.eis.drawer.tab.submissions': '提交记录 ({count})',
  'pages.eis.drawer.tab.events': '事件流水 ({count})',
  'pages.eis.drawer.validationAlert': '本地预校验未通过,未发送给 EIS',
  'pages.eis.drawer.desc.eisUniqueId': 'BIR e-Invoice ID',
  'pages.eis.drawer.desc.prevUniqueId': '原单 EIS ID',
  'pages.eis.drawer.desc.prevEisUniqueId': '原单 EIS ID(已换号)',
  'pages.eis.drawer.desc.orderCreatedAt': '订单创建时间',
  'pages.eis.drawer.desc.issueDtm': '开票时间',
  'pages.eis.drawer.desc.deadlineAt': '推送截止',
  'pages.eis.drawer.desc.deadlineState': '期限状态',
  'pages.eis.drawer.desc.result': 'BIR 结果',
  'pages.eis.drawer.desc.accreditationId': 'EIS 认证号',
  'pages.eis.drawer.desc.attemptCount': '提交次数',
  'pages.eis.drawer.desc.receivedAt': '云端接收',
  'pages.eis.drawer.desc.receivedLate': '(POS 迟到:离线超 3 天才同步)',
  'pages.eis.drawer.desc.reconciliation': '对账状态',
  'pages.eis.drawer.desc.reconciliationFlagged': '待对账',
  'pages.eis.drawer.desc.reconciliationClean': '已核对',
  'pages.eis.drawer.email.section': '客户邮件',
  'pages.eis.drawer.email.placeholder': '客户邮箱',
  'pages.eis.drawer.email.send': '保存并发送',
  'pages.eis.drawer.email.resend': '重新发送',
  'pages.eis.drawer.email.lastError': '上次失败原因:{msg}',
  'pages.eis.drawer.email.queued': '已加入发送队列',
  'pages.eis.drawer.resubmit.queued': '已加入重传队列',
  'pages.eis.drawer.regenerate.done': '已按当前映射重新生成',
  'pages.eis.drawer.json.desc': '冻结的明文 JSON(签名、加密前)· SHA-256 {sha}',
  'pages.eis.drawer.submissions.submitId': 'submitId',
  'pages.eis.drawer.submissions.ackId': 'ackId',
  'pages.eis.drawer.submissions.processStatus': '处理状态',
  'pages.eis.drawer.submissions.submittedAt': '提交时间 (PHT)',
  'pages.eis.drawer.submissions.empty': '尚未提交',
  'pages.eis.drawer.submissions.01': '已完成',
  'pages.eis.drawer.submissions.02': '处理中',
  'pages.eis.drawer.submissions.03': '无法处理',
  'pages.eis.drawer.steps.generate': '生成',
  'pages.eis.drawer.steps.generate.done': '已生成 JSON',
  'pages.eis.drawer.steps.generate.review': '待人工核对',
  'pages.eis.drawer.steps.push': '推送 EIS',
  'pages.eis.drawer.steps.push.held': '过渡期暂存',
  'pages.eis.drawer.steps.push.review': '未发送',
  'pages.eis.drawer.steps.push.acked': '已收到回执',
  'pages.eis.drawer.steps.push.failed': '推送失败',
  'pages.eis.drawer.steps.push.queued': '排队中',
  'pages.eis.drawer.steps.confirm': 'BIR 确认',
  'pages.eis.drawer.steps.confirm.processing': '处理中',
  'pages.eis.drawer.steps.confirm.none': '—',
  'pages.eis.drawer.steps.confirm.rejected': '拒收',
  'pages.eis.drawer.steps.mail': '邮件送达',
  'pages.eis.drawer.event.operator': '操作人 {name}',
  'pages.eis.drawer.event.submitId': 'submitId {id}',
  'pages.eis.drawer.event.ackId': 'ackId {id}',
  'pages.eis.drawer.event.to': '→ {to}',
  'pages.eis.drawer.event.newUniqueId': '新 EIS ID {id}',
} as const;
